<template>
  <div class="show-interval-options">
    <h4>{{ title }}</h4>
    <div style="display: flex">
      <v-text-field
        v-model="fadeTimer"
        persistentPlaceholder
        variant="outlined"
        density="compact"
        type="number"
        hideDetails
        bgColor="#ffffff"
      >
        <template #append-inner>seconds</template>
      </v-text-field>
    </div>
  </div>
</template>

<script setup>
const fadeTimer = defineModel("fadeTimer", { type: Number, required: false, default: 0 });

defineProps({ title: { type: String, required: true } });
</script>
